import { render, staticRenderFns } from "./creatInvoice.vue?vue&type=template&id=6c477847&scoped=true"
import script from "./creatInvoice.vue?vue&type=script&lang=js"
export * from "./creatInvoice.vue?vue&type=script&lang=js"
import style0 from "./creatInvoice.vue?vue&type=style&index=0&id=6c477847&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c477847",
  null
  
)

export default component.exports